import { useState } from "react";
import emailjs from "emailjs-com";
import "./ContactForm.css";

function ContactForm({ defaultService }) {
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const form = e.target;

    const formData = {
      form_type: "Contact Form", // 🔹 for subject line
      from_name: form.name.value,
      
      from_phone: form.phone.value,
      
      message: form.message.value,
    };

    emailjs
      .send(
        "service_lv2cgr7",   // 🔹 Replace with your EmailJS Service ID
        "template_zho5jrs", // 🔹 Replace with your EmailJS Template ID
        formData,
        "IBadFU7RAb1dIjvNz" // 🔹 Replace with your EmailJS Public Key
      )
      .then(
        () => {
          alert("✅ Message Sent! We will get back to you soon.");
          setLoading(false);
          form.reset();
        },
        (err) => {
          console.error("❌ EmailJS Error:", err);
          alert("Failed to send. Please try again.");
          setLoading(false);
        }
      );
  };

  return (
    <div className="contact-page">
      <div className="contact-form">
        <h3>Contact Us</h3>
        <form onSubmit={handleSubmit}>
          <input type="text" name="name" placeholder="Name" required />
          
          <input type="tel" name="phone" placeholder="Phone No" required />

       

          <textarea
            name="message"
            placeholder="Please Write Any Note Here..."
            required
          />

          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ContactForm;
